import { LoginPage } from 'login/login-page';
import { PropsWithChildren } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AuthLayout, PublicLayout } from 'shared/layouts';
import { AuthenticationRequired } from './authentication-required';
import { ParameterRoutes } from './parameter-routes';
import { ProductRoutes } from './product-routes';
import { ROUTES } from './routes';

function Public({ children }: PropsWithChildren<{}>) {
    return <PublicLayout>{children}</PublicLayout>;
}

function Private({ children }: PropsWithChildren<{}>) {
    return (
        <AuthenticationRequired>
            <AuthLayout>{children}</AuthLayout>
        </AuthenticationRequired>
    );
}

function PrivateRoutes() {
    return (
        <Private>
            <Switch>
                <Route path={ROUTES.products}>
                    <ProductRoutes />
                </Route>
                <Route path={ROUTES.parameters}>
                    <ParameterRoutes />
                </Route>
                <Route path='*'>
                    <Redirect to={ROUTES.login} />
                </Route>
            </Switch>
        </Private>
    );
}

export function AppRoutes() {
    return (
        <Switch>
            <Route path={ROUTES.login} exact>
                <Public>
                    <LoginPage />
                </Public>
            </Route>
            <Route path='*'>
                <PrivateRoutes />
            </Route>
        </Switch>
    );
}
